import { handleActions } from 'redux-actions';
import { GENE_FIRST_BIND, GENE_STATUS } from '../actionTypes';
import { gene } from '../initialState';

export default handleActions(
  {
    [GENE_FIRST_BIND]: (state, action) => {
      return {
        ...state,
        firstBind: action.payload
      };
    },
    [GENE_STATUS]: (state, action) => {
      return {
        ...state,
        status: action.payload
      };
    }
  },
  gene
);
